import './cart.scss';
import './button.scss';

import { CartProvider, ThemeProvider } from '@boost-sd/app';
import { createRoot } from 'react-dom/client';

export const initCart = () => {
  const cartContainerId = 'boost-sd__cart-container';
  const cartContainer = document.createElement('div');
  cartContainer.setAttribute('id', cartContainerId);

  const body = document.body;
  body.appendChild(cartContainer);
  if (
    window.boostSDAppConfig.themeSettings.cart.enableCart &&
    window.boostSDAppConfig.themeSettings.cart.cartStyle !== 'none'
  ) {
    body.classList.add('boost-sd__ajax-cart-enabled');
  }

  const root = createRoot(cartContainer);

  const updateCartIconHeader = (cartItemCount: number) => {
    const cartCountEls = document.querySelectorAll('.js-cart-count');

    cartCountEls.forEach((item) => (item.innerHTML = cartItemCount.toString()));
  };

  root.render(
    <ThemeProvider>
      <CartProvider
        cartIconHeaderSelector='.js-mini-cart-trigger'
        onUpdateCart={updateCartIconHeader}
      />
    </ThemeProvider>
  );
};
